
import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import "./login.css";
import { jwtDecode } from "jwt-decode"
import { Form, Input, Button, message } from "antd";
import { useNavigate, Navigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();

  //谷歌登录成功后的逻辑
  const handleLoginSuccess = (credentialResponse) => {
    console.log(jwtDecode(credentialResponse.credential));
    let userMessages = {
      email: jwtDecode(credentialResponse.credential).email,
      name: jwtDecode(credentialResponse.credential).family_name,
      password: 123456,
    }
    navigate("/Main")
    resgister(userMessages)
    return message.open({
      type: 'success',
      content: 'Login successful',
    });
  };
  // 在这里处理登录失败后的逻辑
  const handleLoginFailure = () => {
    console.log('Login Failed');
  };

  //注册
  const resgister = async (message) => {
    try {
      const res = await fetch('//dai.caihuiltd.com/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(message),
      });
      const data = await res.json();
      // console.log(data);

      localStorage.setItem("token", `${message.email}+${data.user_id}`);
      navigate("/Main")
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };




  if (localStorage.getItem("token")) {
    return <Navigate to="/Main/home" replace />;
  }
  const handleSubmit = val => {
    if (!val.password || !val.email) {
      return message.open({
        type: "warning",
        content: "Please enter your email and password  ",
      });
    }
    console.log(val);
    login(val)


  };

  const login = async (messages) => {
    try {
      const res = await fetch('//dai.caihuiltd.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({ message: messages }),
      });
      const data = await res.json();
      console.log(data);

      if (data.message === 'Login successful') {
        message.open({
          type: 'success',
          content: data.message,
        });
        localStorage.setItem("token", `${messages.email}+${data.user_id}`);
        navigate("/Main")
      } else {
        message.open({
          type: 'error',
          content: data.error
        });
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <Form className="login-container" onFinish={handleSubmit}>
      <div className="login_title">Login</div>
      <Form.Item label="Email" name="email">
        <Input placeholder="
Please enter your email" />
      </Form.Item>
      <Form.Item label="Password" name="password">
        <Input.Password placeholder="
Please enter account number" />
      </Form.Item>
      <Form.Item className="login-button">

        <Button type="primary" htmlType="submit">
          Login
        </Button>
      </Form.Item>
      <GoogleOAuthProvider
        className="go-resgister"
        clientId="1011273448593-dalvf67mm25iddvjp91hcln3hblr5bre.apps.googleusercontent.com">
        <GoogleLogin
          className="go-resgister"
          clientId="1011273448593-dalvf67mm25iddvjp91hcln3hblr5bre.apps.googleusercontent.com"
          buttonText="Sign in with Google"
          onSuccess={handleLoginSuccess}
          onFailure={handleLoginFailure}
        // cookiePolicy={'single_host_origin'}
        />
      </GoogleOAuthProvider>
      <Button color="primary" type="link" className="go-resgister" onClick={() => navigate("/register")}>
        Don't have an account?
      </Button>
    </Form>
  );
};

export default Login;